import { useCallback } from 'react'

import { DraftMessage, DraftMessageType } from '../types.js'

import { useDraftChats } from './DraftChatsProvider.js'

interface Props {
  chatId: string
}

export const useHandleChatDrafts = ({ chatId }: Props) => {
  const { getChatDraft, updateChatDraft, draftsLoaded } = useDraftChats()

  /**
   * To avoid re-rendering as user types, the draft content is updated
   * separately in a debounced manner.
   */
  const handleUpdateDraftContent = useCallback(
    (content: string, draftMessage: DraftMessage) => {
      if (chatId) {
        updateChatDraft(
          {
            attachments: draftMessage.attachments,
            embeds: draftMessage.embeds,
            content,
          },
          chatId,
        )
      }
    },
    [chatId, updateChatDraft],
  )

  const saveChatDraft = useCallback(
    (draftMessage: DraftMessage) => {
      if (draftMessage.type === DraftMessageType.Edit) {
        return
      }

      if (chatId) {
        updateChatDraft(
          {
            attachments: draftMessage.attachments,
            embeds: draftMessage.embeds,
            content: draftMessage.content,
          },
          chatId,
        )
      }
    },
    [chatId, updateChatDraft],
  )

  return {
    getChatDraft,
    updateChatDraft,
    draftsLoaded,
    handleUpdateDraftContent,
    saveChatDraft,
  }
}
